
import type { App } from 'vue'
import component from './OrderListFooterBtn.vue'
const install = (app: App): void => {
	app.component(component.name, component)
}

export default {
	install,
	component
}
